<template>
  <base-dialog
    v-model="show"
    @close="close"
    :loading="loading"
    disabledAction
    fullscreen
    content-class="disable-dialog-scroll"
  >
    <template v-slot:title> {{ title }} </template>
    <div class="d-flex flex-column full-height">
      <div class="d-flex py-2 flex-grow-0">
        <v-text-field
          hide-details
          label="Nhập để tìm kiếm"
          outlined
          prepend-inner-icon="mdi-magnify"
          v-model="params.search"
          dense
        ></v-text-field>
      </div>
      <div class="flex-grow-1 overflow-auto">
        <base-serve-table
          v-if="show"
          ref="table"
          :api="api"
          :headers="headers"
          :params.sync="params"
          :defaultParams="default_params"
          sync-params
        >
          <template v-slot:[`item.type`]="{ item }">
            <span v-if="item.type">
              {{ $t(`property.type.${item.type}`) }}
            </span>
          </template>
          <template v-slot:[`item.static`]="{ item }">
            <div class="text-center">
              <v-icon v-if="item.static">mdi-check-circle-outline</v-icon>
            </div>
          </template>
        </base-serve-table>
      </div>
    </div>
  </base-dialog>
</template>

<script>
import { API_LAYER_FIELD } from '@api'
import { ConfirmBuilder, copyByJson, debounce, replaceLink } from '@utils'
import { isString } from 'lodash'
import { EDIT_TYPE } from '@constant'
export default {
  components: {},
  props: {
    layer_id: { type: Number, required: true },
    title: { type: String, default: 'Trường dữ liệu lớp' },
  },
  data: (vm) => ({
    show: false,
    loading: false,
    default_params: null,
    headers: [
      {
        trans: 'field-detail.name',
        align: 'start',
        sortable: true,
        value: 'name',
      },
      {
        trans: 'field-detail.type',
        align: 'start',
        sortable: false,
        value: 'type',
      },
      {
        trans: 'field-detail.static',
        align: 'start',
        sortable: false,
        value: 'static',
      },
      {
        trans: 'field-detail.description',
        align: 'start',
        sortable: false,
        value: 'description',
      },
    ],
    menus: [
      {
        type: 'update',
        handler: (item) => vm.onUpdateItem(item),
      },
      {
        type: 'delete',
        handler: (item) => vm.onDeleteItem(item),
        disabled: (item) => item.static,
      },
    ],
    params: { search: '' },
  }),
  watch: {},
  computed: {
    api() {
      return API_LAYER_FIELD.updateOption({
        url: replaceLink(API_LAYER_FIELD.getUrl(), { id: this.layer_id }),
      })
    },
  },
  created() {
    // console.log(this.api)
  },
  methods: {
    open() {
      this.params = { search: '', page: null }
      this.show = true
    },
    close() {
      this.show = false
      this.loading = false
    },
    onUpdateItem(item) {
      this.$refs.dialog.open(item, EDIT_TYPE.UPDATE)
    },
    async onDeleteItem(item) {
      let confirm = new ConfirmBuilder()
      confirm
        .initByType('delete')
        .setTitle('confirm.title')
        .setOption({
          color: 'error',
        })
      if (await confirm.confirm()) {
        const result = await API_LAYER_FIELD.destroy(item.id)
        if (result && result.isDone) {
          this.onReset()
          this.onResetLayer()
        }
      }
    },
    onReset() {
      this.fetchData()
    },
    onResetLayer() {
      this.$emit('reset-layer')
    },
    fetchData() {
      this.loading = true
      this.api
        .list(this.params)
        .then((res) => {
          this.items = res.data.data
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style scoped></style>
